import { ref, nextTick, watch, watchEffect } from "@nuxtjs/composition-api";
import { createEventHook, useElementBounding, useScroll } from "@vueuse/core";
import { isClient } from "~/utils/helpers";

import {useScrollParent} from './useScrollParent';


// export function useScrollParent(
//     el,
//     root = isClient() ? window : undefined
// ) {
//     const scrollParent = ref();

//     onMounted(() => {
//         if (el.value) {
//             scrollParent.value = getScrollParent(el.value, root);
//         }
//     });

//     return scrollParent;
// }


export default function useInfiniteLoading(props = {
    loading: false,
    finished: false
}) {
    const loading = ref(props.loading);
    const finished = ref(props.finished);
    // const disabled = ref(props.disabled);
    // const error = ref(props.error);
    const root = ref();
    const scrollParent = useScrollParent(root);
    // const scrollParentRect = useElementBounding(scrollParent);
    // const placeholderRect = useElementBounding(placeholder);

    const loadHook = createEventHook();


    const { arrivedState } = useScroll(scrollParent, {
        offset: {
            bottom: props.distance
        },
        onScroll() {
            if (loading.value || finished.value || props.disabled || props.error) {
                return;
            }
            if (arrivedState.bottom) {
                loadHook.trigger();
            }
        }
    })
    // watchEffect(() => {
    //     console.log(root.value, scrollParent.value)
    // })
    const updateLoading = (v) => loading.value = v;
    const updateFinished = (v) => finished.value = v;
    return {
        loading,
        finished,
        root,
        onLoad: loadHook.on,

        updateLoading,
        updateFinished
    }
}